import scanRoutes from './route';

export default scanRoutes;